import { defineStore } from 'pinia';
import SaleTypesAPI from 'dashboard/api/saleTypes';

export const useSaleTypesStore = defineStore('saleTypes', {
  state: () => ({
    types: [],
    isFetching: false,
    isSaving: false,
  }),

  actions: {
    async fetch() {
      this.isFetching = true;
      try {
        const { data } = await SaleTypesAPI.get();
        this.types = data.sale_types || [];
      } finally {
        this.isFetching = false;
      }
    },

    async save(types) {
      this.isSaving = true;
      try {
        const { data } = await SaleTypesAPI.update(types);
        this.types = data.sale_types || [];
      } finally {
        this.isSaving = false;
      }
    },
  },
});
